import React from 'react';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import ScoringParameterCard from './ScoringParameterCard';

const useStyle = makeStyles({
  content: {
    gap: '20px',
    paddingBottom: '10px',
  },
  required_field: {
    color: '#667085',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  option_field: {
    color: '#667085',
  },
  inputField: {
    width: '96%',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: 'white',
    fontSize: '14px',
  },
  textArea: {
    width: '98%',
    height: '70px',
    padding: '15px 10px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
    outline: 'none',
    marginTop: '5px',
    background: 'white',
    fontSize: '14px',
    resize: 'none',
    fontFamily: 'sans-serif',
  },
  smalltext: {
    font: '14px',
    color: '#667085',
    marginRight: '5px',
  },
  bold: {
    color: '#10182B',
    gontSize: '16px',
    marginBottom: '10px',
  },
  totalCharacterCount: {
    fontSize: '12px',
    fontWeight: 600,
    color: '#10182B',
    backgroundColor: '#f5f5f5',
    padding: '10px 20px',
    borderRadius: '5px',
    border: '1px solid #E4E7EC',
  },
});

export const RoleplayConfig = ({ exerciseInfo, handleChange }) => {
  const classes = useStyle();

  // Initialize reportingParameters
  const reportingParameters = exerciseInfo.reportingParameters || [
    { name: '', description: '', instructions: [] },
    { name: '', description: '', instructions: [] },
    { name: '', description: '', instructions: [] },
  ];

  // Calculate total character count including reporting parameters
  const reportingParamsCharCount = reportingParameters.reduce(
    (sum, param) =>
      sum + (param.name?.length || 0) + (param.description?.length || 0) + (param.instructions?.join(' ')?.length || 0),
    0,
  );

  const totalCharacterCount =
    (exerciseInfo.goal?.length || 0) +
    (exerciseInfo.context?.length || 0) +
    (exerciseInfo.instruction?.length || 0) +
    reportingParamsCharCount;

  const totalScore = 30; // Hardcoded for now.
  const passingScore = exerciseInfo.passingPercentage ? (Number(exerciseInfo.passingPercentage) * totalScore) / 100 : 0;

  // Handle changes to reporting parameters
  const handleParameterChange = (index, field, value) => {
    const updatedParameters = [...reportingParameters];
    updatedParameters[index] = {
      ...updatedParameters[index],
      [field]: value,
    };
    const event = {
      target: {
        value: updatedParameters,
      },
    };
    handleChange(event, 'reportingParameters');
  };

  return (
    <Grid container style={{ height: '100%' }}>
      <Grid item xs={12}>
        <Grid container className={classes.content}>
          <Grid item xs={12}>
            <Grid container style={{ marginBottom: '20px' }}>
              <Typography className={classes.totalCharacterCount}>
                Total Character Count: {totalCharacterCount}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container justifyContent="space-between">
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                    <Grid container justifyContent="space-between">
                      <Typography className={classes.required_field}>Goal for the Bot </Typography>
                      <Typography className={classes.smalltext}>{exerciseInfo.goal?.length} chars</Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <textarea
                      placeholder="Enter intro here"
                      className={classes.textArea}
                      value={exerciseInfo.goal}
                      onChange={(e) => handleChange(e, 'goal')}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container justifyContent="space-between">
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                    <Grid container justifyContent="space-between">
                      <Typography className={classes.required_field}>Context for the Bot </Typography>
                      <Typography className={classes.smalltext}>{exerciseInfo.context?.length} chars</Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <textarea
                      className={classes.textArea}
                      value={exerciseInfo.context}
                      onChange={(e) => handleChange(e, 'context')}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <Grid container justifyContent="space-between">
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={12}>
                    <Grid container justifyContent="space-between">
                      <Typography className={classes.required_field}>Instructions for the Bot </Typography>
                      <Typography className={classes.smalltext}>{exerciseInfo.instruction?.length} chars</Typography>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <textarea
                      className={classes.textArea}
                      value={exerciseInfo.instruction}
                      onChange={(e) => handleChange(e, 'instruction')}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <ScoringParameterCard data={reportingParameters[0]} index={0} handleChange={handleParameterChange} />
          </Grid>

          <Grid item xs={12}>
            <ScoringParameterCard data={reportingParameters[1]} index={1} handleChange={handleParameterChange} />
          </Grid>

          <Grid item xs={12}>
            <ScoringParameterCard data={reportingParameters[2]} index={2} handleChange={handleParameterChange} />
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={12}>
                <Typography>Total Score of the Exercise (sum of above 3 parameters)</Typography>
              </Grid>
              <Grid item xs={12}>
                <input placeholder="ex. 10" className={classes.inputField} value={totalScore} disabled />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography>Passing % (out of 100)</Typography>
                <input
                  placeholder="ex. 10"
                  className={classes.inputField}
                  value={exerciseInfo.passingPercentage}
                  onChange={(e) => handleChange(e, 'passingPercentage')}
                />
              </Grid>

              <Grid item xs={6}>
                <Typography>Passing Score (based on the passing % entered)</Typography>
                <input className={classes.inputField} value={passingScore} disabled />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
